const normalizeSourceMetadata = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  return Object.fromEntries(
    Object.entries(value).slice(0, 24).map(([key, entry]) => [
      String(key).slice(0, 80),
      typeof entry === "string" ? entry.slice(0, 1200) : entry,
    ]),
  );
};
const sourceMetadataFields = (value) => {
  const normalized = normalizeSourceMetadata(value);
  return normalized
    ? {
      sourceMetadata: normalized,
      ...(normalized.provider
        ? { sourceProvider: String(normalized.provider).slice(0, 80) }
        : {}),
    }
    : {};
};

export const buildUserUploadDocumentPayload = ({
  caseId,
  filename,
  s3Key,
  base64,
  docketEntryId,
  lifecycleStageId,
  documentType,
  sourceMetadata,
  source = "user_upload",
}) => ({
  docketId: caseId,
  filename,
  ...(source ? { source } : {}),
  ...(s3Key ? { s3Key } : { base64 }),
  ...(docketEntryId ? { docketEntryId } : {}),
  // Company workspaces file uploads under a lifecycle stage and document type.
  ...(lifecycleStageId ? { lifecycleStageId } : {}),
  ...(documentType ? { documentType } : {}),
  ...sourceMetadataFields(sourceMetadata),
});
